// src/components/AuthorizedLayout.jsx
import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Provider as JotaiProvider } from 'jotai'
import Preloader from '../components/Preloader/Preloader'
import RequireAuth from './RequireAuth'
import EditorConfigProvider from '../template-configs/EditorConfig'
import WithProjectNavigation from '../components/core/ProjectNavigation'
import UpgradePlanModal from '../components/core/UpgradePlanModal'
import ClaimDiscountModal from '../components/core/DiscountModal'
import FreePlanScriptSelector from '../components/core/FreePlanScriptSelector/FreePlanScriptSelector'
import WorkspaceInvitationResume from '../components/core/WorkspaceInvitationResume/WorkspaceInvitationResume'
import WorkspaceRemovalNotice from '../components/core/WorkspaceRemovalNotice/WorkspaceRemovalNotice'
import { userCredits, projectsStore } from '../AppJotaiStores'

export default function AuthorizedLayout () {
  return (
    <Suspense fallback={<Preloader />}>
      <RequireAuth>
        <EditorConfigProvider>
          <JotaiProvider store={userCredits}>
            <JotaiProvider store={projectsStore}>
              <WithProjectNavigation>
                <Outlet />
                <FreePlanScriptSelector />
                <WorkspaceInvitationResume />
                <WorkspaceRemovalNotice />
              </WithProjectNavigation>
            </JotaiProvider>
          </JotaiProvider>
        </EditorConfigProvider>
        <UpgradePlanModal />
        <ClaimDiscountModal />
      </RequireAuth>
    </Suspense>
  )
}
